<script lang="ts">
	import * as Accordion from '$lib/components/ui/accordion/index.js';
	import type { ComponentSectionsQuestions } from '$lib/graphql/strapiApi';

	let { content }: { content: ComponentSectionsQuestions } = $props();
</script>

<div class="flex w-full flex-col items-center">
	<h1 class="mb-4 text-4xl font-bold">{content.title}</h1>
	{#if content.description}
		<h2 class="mb-4 text-2xl font-bold">{content.description}</h2>
	{/if}
	<Accordion.Root type="multiple" class="w-full max-w-screen-sm">
		{#each content.questions ?? [] as question}
			<Accordion.Item value={question?.id}>
				<Accordion.Trigger class="font-semibold">{question?.question}</Accordion.Trigger>
				<Accordion.Content>{question?.answer}</Accordion.Content>
			</Accordion.Item>
		{/each}
	</Accordion.Root>
</div>
